// src/types/properties/ImageCategory.ts
var IMAGE_OWNER_KINDS = ["property", "experience", "service"];
var PropertyImageCategory = /* @__PURE__ */ ((PropertyImageCategory2) => {
  PropertyImageCategory2["Exterior"] = "exterior";
  PropertyImageCategory2["Backyard"] = "backyard";
  PropertyImageCategory2["Pool"] = "pool";
  PropertyImageCategory2["Patio"] = "patio";
  PropertyImageCategory2["Balcony"] = "balcony";
  PropertyImageCategory2["Neighbourhood"] = "neighbourhood";
  PropertyImageCategory2["General"] = "general";
  return PropertyImageCategory2;
})(PropertyImageCategory || {});
var UnitImageCategory = /* @__PURE__ */ ((UnitImageCategory2) => {
  UnitImageCategory2["LivingRoom"] = "living_room";
  UnitImageCategory2["DiningArea"] = "dining_area";
  UnitImageCategory2["Kitchen"] = "kitchen";
  UnitImageCategory2["Bedroom"] = "bedroom";
  UnitImageCategory2["Bathroom"] = "bathroom";
  return UnitImageCategory2;
})(UnitImageCategory || {});
var ListingImageCategory = /* @__PURE__ */ ((ListingImageCategory2) => {
  ListingImageCategory2["Cover"] = "cover";
  ListingImageCategory2["Highlights"] = "highlights";
  return ListingImageCategory2;
})(ListingImageCategory || {});
var CATEGORY_BY_ASSET = {
  property: Object.values(PropertyImageCategory),
  unit: Object.values(UnitImageCategory),
  listing: Object.values(ListingImageCategory)
};
var SLOT_INVENTORY_IMAGE_CATEGORIES = [
  "cover" /* Cover */,
  "highlights" /* Highlights */,
  "general" /* General */
];
var SLOT_INVENTORY_COVER_CATEGORY = "cover" /* Cover */;
function isSlotInventoryCategory(category) {
  return SLOT_INVENTORY_IMAGE_CATEGORIES.includes(category);
}
function isCategoryValidForAsset(category, asset) {
  return CATEGORY_BY_ASSET[asset].includes(category);
}
function resolveAssetForCategory(category) {
  for (const [asset, categories] of Object.entries(CATEGORY_BY_ASSET)) {
    if (categories.includes(category)) {
      return asset;
    }
  }
  return void 0;
}
var ImageFlagStatus = /* @__PURE__ */ ((ImageFlagStatus2) => {
  ImageFlagStatus2["None"] = "none";
  ImageFlagStatus2["Pending"] = "pending";
  ImageFlagStatus2["Resolved"] = "resolved";
  ImageFlagStatus2["Dismissed"] = "dismissed";
  return ImageFlagStatus2;
})(ImageFlagStatus || {});
var ImageProcessingStatus = /* @__PURE__ */ ((ImageProcessingStatus2) => {
  ImageProcessingStatus2["Pending"] = "pending";
  ImageProcessingStatus2["Ready"] = "ready";
  ImageProcessingStatus2["Rejected"] = "rejected";
  return ImageProcessingStatus2;
})(ImageProcessingStatus || {});
function describeImageRejection(ai) {
  if (!ai) return ["Not verified by AI (verification was unavailable at upload)."];
  const reasons = [];
  if (!ai.is_real_photo)
    reasons.push("Not a genuine photo (looks AI-generated, a screenshot, or a meme).");
  if (!ai.matches_category) {
    reasons.push(
      ai.suggested_category ? `Doesn't match the selected category (looks more like "${ai.suggested_category}").` : "Doesn't match the selected category."
    );
  }
  if (!ai.is_appropriate) reasons.push("Contains inappropriate content.");
  if (ai.has_text_or_watermarks) reasons.push("Contains text, watermarks, or ads.");
  if (!ai.is_quality_acceptable)
    reasons.push("Low image quality (blurry, dark, or low resolution).");
  if (ai.has_people) reasons.push("Contains identifiable people.");
  if (reasons.length === 0) {
    if (ai.flags?.length) return ai.flags.map((f) => f.replace(/_/g, " "));
    return ["Did not pass automated image checks."];
  }
  return reasons;
}

export {
  IMAGE_OWNER_KINDS,
  PropertyImageCategory,
  UnitImageCategory,
  ListingImageCategory,
  CATEGORY_BY_ASSET,
  SLOT_INVENTORY_IMAGE_CATEGORIES,
  SLOT_INVENTORY_COVER_CATEGORY,
  isSlotInventoryCategory,
  isCategoryValidForAsset,
  resolveAssetForCategory,
  ImageFlagStatus,
  ImageProcessingStatus,
  describeImageRejection
};
